import styled from "styled-components"
import MakeCategory from "./Category/MakeCategory"
import ShowCategoryList from "./Category/ShowCategoryList"
import CreateTodoElement from "./TodoBox/CreateTodoElement"
import ToDoList from "./TodoBox/ToDoList"

const Wrapper = styled.main`
  display: flex;
  margin : 0.1rem;
  flex-direction: column;
  align-items: center;
  background-color: #ff000014;
  height: 100%;
  padding:5em;
  border: none;
  border-radius: 10px;

`

const Title = styled.main`
  margin : 0.1rem 0 2em 0;
  font-size: large;
  font-weight: bold;
  background-color: #cfc4ff3b;
  border-radius: 2rem;
  padding: 1em;
  width: 70%;
  text-align: center;
  color:#302d3d;
  font-family: 'Courier New', Courier, monospace;
`
const ToDoListPage = () => {
  return (
    <Wrapper>
      <Title>Hailey's To Do Lists</Title>
      <MakeCategory />
      <ShowCategoryList />
      <CreateTodoElement />
      <ToDoList />
    </Wrapper>
  )
}
export default ToDoListPage